import useBreadcrumbs from "@lib/composables/layout/breadcrumbs";

export default defineNuxtRouteMiddleware((to, from) => {
  const { setBreadcrumbsConfig } = useBreadcrumbs();
  const { $i18n } = useNuxtApp();

  if (to?.name !== from?.name) {
    setBreadcrumbsConfig({
      items: [
        {
          title: `${$i18n.t("common.loading")}...`,
          uppercase: true,
        },
      ],
    });
  }
});
